import { render, staticRenderFns } from "./PlusAcademyActivity.vue?vue&type=template&id=e712c49c&scoped=true"
import script from "./PlusAcademyActivity.vue?vue&type=script&lang=js"
export * from "./PlusAcademyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e712c49c",
  null
  
)

export default component.exports